import get from 'lodash/get'

const _ = { get }

export default {
  inject: { sserrors: { default: () => ({}) } },
  data() {
    return {
      sserrorsLocal: this.sserrors
    }
  },
  computed: {
    sserror: function() {
      return !this.preferredValidator.$dirty
        ? _.get(this.sserrorsLocal.errors, this.name, '')
        : ''
    },
    activeErrorMessagesBoth: function() {
      return this.activeErrorMessages && this.activeErrorMessages.length
        ? this.activeErrorMessages[0]
        : this.sserror.length
        ? this.sserror
        : ''
    },
    hasErrorsBoth: function() {
      return this.hasError || this.sserror.length
    }
  }
}
